<template>
	<div>
		<div class="display-flex flex-direction-column align-items-center">
			<h1 class="heading-2 pt-50 pb-100 text-align-center" data-test="micro-feedback-thank-you"> Thank you </h1>
			<BaseSvgIcon class="pt-100" height="120" width="120" name="hd-checkmark" />
			<p class="pt-50 pb-100 text-align-center"> Your feedback makes the Fundrise experience even better. </p>
		</div>
		<BaseButtonGroup :centered="true">
			<template #primary>
				<BaseLink
					classes="button button-primary"
					:link="successLink"
					:data-test="`micro-feedback-success-${successLink.router}-link`"
				/>
			</template>
		</BaseButtonGroup>
	</div>
</template>

<script setup lang="ts">
import { computed, ref, Ref } from 'vue';
import { Link } from 'types/layout';
import { MicroFeedbackType } from 'types/micro-feedback';
import { useRoute } from 'vue-router';

const route = useRoute();

const eventType: Ref<MicroFeedbackType | null> = ref(null);
const associatedEventId = ref('');

const successLink = computed(
	(): Link =>
		eventType.value === 'INVESTOR_UPDATE'
			? {
					text: 'Return to Investor Update',
					router: 'investor-update',
					params: { investorUpdateId: associatedEventId.value }
				}
			: { text: 'Continue to account overview', router: 'account-overview' }
);

function setup(): void {
	eventType.value = route.query['eventType']?.toString() as MicroFeedbackType;
	associatedEventId.value = route.query['associatedEventId']?.toString() ?? '';
}

setup();
</script>
